import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import React, { useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

interface BasicTabProps {
  labels: string[];
  tabContent: React.ReactNode;
  onChangeTab: (newIndex: number) => void;
  inProgress?: boolean;
  currentTab: number;
}

const SimpleTabComponent = ({
  labels,
  inProgress,
  tabContent,
  onChangeTab,
  currentTab,
}: BasicTabProps) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onChangeTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: '0px' }}>
        <Tabs value={currentTab} onChange={handleChange}>
          {labels.map((label: any, index: number) => {
            return (
              <Tab disabled={inProgress} label={label} {...a11yProps(index)} />
            );
          })}
        </Tabs>
      </Box>
      <Box>
        <CustomTabPanel value={currentTab} index={currentTab}>
          {tabContent}
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default SimpleTabComponent;
